import { Directive, ElementRef, inject, input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { gameManager } from 'src/app/game/businesslogic/GameManager';
import { GhsManager } from 'src/app/game/businesslogic/GhsManager';
import { settingsManager } from 'src/app/game/businesslogic/SettingsManager';
import { ActionHex, ActionHexFromString } from 'src/app/game/model/ActionHex';
import { ActionType, ActionTypesIcons } from 'src/app/game/model/data/Action';
import {
  additionalTownGuardAttackModifier,
  AttackModifierType,
  AttackModifierValueType,
  defaultTownGuardAttackModifier
} from 'src/app/game/model/data/AttackModifier';
import { Condition, ConditionType } from 'src/app/game/model/data/Condition';
import { EntityValueFunction, EntityValueRegex } from 'src/app/game/model/Entity';
import { ghsValueSign } from 'src/app/ui/helper/Static';

export const ghsLabelRegex = /%([\w\s.,:+()|[\]{}$\/\\\-\u200B]+)%/;

export const applyPlaceholder = function (
  input: string,
  placeholder: string[] = [],
  relative: boolean = false,
  style: 'gh' | 'fh' | false = false
): string {
  const fh = (!style && settingsManager.settings.fhStyle) || style === 'fh';
  let output = input;
  while (output.match(ghsLabelRegex)) {
    output = output.replace(ghsLabelRegex, (match, ...args) => {
      let label: string = args[0];
      let value = '';
      if (label.includes(':')) {
        value = label.split(':')[1];
        label = label.split(':')[0];
      }
      const split: string[] = label.split('.');
      if (!value && args[0].includes(':')) {
        value = split[split.length - 1];
      }

      if (!value) {
        value = '';
      }

      const prefix = split[0];
      const type = split[1];

      let replace: string = match;
      let image: string = '';
      if (type === 'condition' || type === 'immunity') {
        const condition = new Condition(split[2]);
        image = '<span class="condition-icon' + (type === 'immunity' ? ' immunity' : '') + '">';
        image += '<img  src="./assets/images/' + (fh ? 'fh/' : '') + 'condition/' + condition.name + '.svg" class="icon">';
        if (!value && condition.types.includes(ConditionType.upgrade)) {
          value = 'X';
        }
        if (value) {
          image += '<span class="value">' + value + '</span>';
        }
        image += '</span>';
        replace =
          '<span class="placeholder-condition' +
          (fh ? ' fh' : '') +
          '">' +
          (fh ? '&#8203;' : settingsManager.getLabel('game.condition.' + condition.name, [value ? value : ''])) +
          image +
          '</span>';
      } else if (type === 'conditionIcon' || type === 'immunityIcon') {
        const condition = new Condition(split[2]);
        image = '<span class="condition-icon' + (type === 'immunityIcon' ? ' immunity' : '') + '">';
        image += '<img  src="./assets/images/' + (fh ? 'fh/' : '') + 'condition/' + condition.name + '.svg" class="icon">';
        if (!value && condition.types.includes(ConditionType.upgrade)) {
          value = 'X';
        }
        if (value) {
          image += '<span class="value">' + value + '</span>';
        }
        image += '</span>';
        replace = '<span class="placeholder-condition">&#8203;' + image + '</span>';
      } else if (
        type === 'action' &&
        split.length === 3 &&
        !split[2].startsWith('specialTarget') &&
        !split[2].startsWith('summon') &&
        !split[2].startsWith('area')
      ) {
        split.splice(0, 1);
        const ghsSvg = ActionTypesIcons.includes(split[split.length - 1] as ActionType);
        image =
          '<img  src="./assets/images/' + (fh ? 'fh/' : '') + split.join('/') + '.svg" class="icon' + (ghsSvg ? ' ghs-svg' : '') + '">';
        replace =
          '&#8203;<span class="placeholder-action">' + (fh ? '&#8203;' : settingsManager.getLabel(label)) + image + value + '</span>';
      } else if (
        type === 'action' &&
        split.length === 4 &&
        !isNaN(+value) &&
        !split[2].startsWith('specialTarget') &&
        !split[2].startsWith('summon') &&
        !split[2].startsWith('area') &&
        split[3] === 'valueSign'
      ) {
        split.splice(0, 1);
        split.splice(-1, 1);
        const ghsSvg = ActionTypesIcons.includes(split[split.length - 1] as ActionType);
        image =
          '<img  src="./assets/images/' + (fh ? 'fh/' : '') + split.join('/') + '.svg" class="icon' + (ghsSvg ? ' ghs-svg' : '') + '">';
        replace =
          '&#8203;<span class="placeholder-action">' +
          ghsValueSign(+value) +
          '&nbsp;' +
          (fh ? '' : settingsManager.getLabel('game.action.' + split[1])) +
          image +
          '</span>';
      } else if (
        type === 'actionIcon' &&
        split.length === 3 &&
        !split[2].startsWith('specialTarget') &&
        !split[2].startsWith('summon') &&
        !split[2].startsWith('area')
      ) {
        split.splice(0, 1);
        const ghsSvg = ActionTypesIcons.includes(split[split.length - 1] as ActionType);
        image =
          '<img  src="./assets/images/' +
          (fh ? 'fh/action/' : 'action/') +
          split[split.length - 1] +
          '.svg" class="icon' +
          (ghsSvg ? ' ghs-svg' : '') +
          '">';
        replace = '&#8203;<span class="placeholder-action">&#8203;' + image + value + '</span>';
      } else if (type === 'actionText' && split.length === 3) {
        replace = '&#8203;<span class="placeholder-action">' + settingsManager.getLabel('game.action.' + split[2]) + '</span>';
      } else if (type === 'element') {
        let element = split[2];
        if (element === 'consume') {
          image = '<span class="element inline consume">';
          element = split[3];
        } else {
          image = '<span class="element inline">';
        }
        image += '<img src="./assets/images/' + (fh ? 'fh/' : '') + 'element/' + element + '.svg"></span>';
        replace = image;
      } else if (type === 'elementHalf') {
        let consume: boolean = false;
        if (split[2] && split[2].startsWith('consume')) {
          consume = true;
        }
        const elements = value.split('|');
        replace =
          '<span class="attack-modifier-effect placeholder-element-half element-half-placeholder' +
          (fh ? ' fh' : '') +
          '"><span class="element-half-container' +
          (consume ? ' consume' : '') +
          '"><span class="element-half"><img src="./assets/images/' +
          (fh ? 'fh/' : '') +
          'element/' +
          elements[0] +
          '.svg"></span><span class="element-half"><img src="./assets/images/' +
          (fh ? 'fh/' : '') +
          'element/' +
          elements[1] +
          '.svg"></span></span></span>';
      } else if (type === 'action' && split[2].startsWith('area')) {
        replace = '<span class="placeholder-area">';

        if (split[2] === 'areaRotated') {
          replace = '<span class="placeholder-area" style="transform:rotate(-90deg);">';
        }

        value.split('|').forEach((hexValue) => {
          const hex: ActionHex | null = ActionHexFromString(hexValue);
          if (hex !== null) {
            replace +=
              '<span class="hex" style="grid-column-start : ' +
              (hex.x * 2 + 1 + (hex.y % 2)) +
              ';grid-column-end:' +
              (hex.x * 2 + 3 + (hex.y % 2)) +
              ';grid-row-start:' +
              (hex.y + 1) +
              ';grid-row-end:' +
              (hex.y + 1) +
              '"><img src="./assets/images/action/hex/' +
              hex.type +
              '.svg"></span>';
          }
        });
        replace += '</span>';
      } else if (type === 'initiative' && split.length === 3) {
        image = '<img class="ghs-svg" src="./assets/images/initiative.svg"></span>';
        replace = '<span class="placeholder-initiative">' + split[2] + image + '</span>';
      } else if (type === 'action' && split.length === 4) {
        image = '<img  src="./assets/images/action/' + split[2] + '/' + split[3] + '.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-perk">' + image + value + '</span>';
      } else if (prefix === 'game' && type === 'items' && split.length === 4) {
        image = '<img  src="./assets/images/items/' + split[2] + '/' + split[3] + '.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-item-slot">' + image + value + '</span>';
      } else if (prefix === 'game' && type === 'itemFh' && split.length === 3) {
        if (split[2] === 'random') {
          replace =
            '<span class="placeholder-item-fh"><span class="value"><img src="./assets/images/fh/loot/random_item.svg"></span></span>';
        } else {
          const itemId: number = +split[2];
          replace =
            '<span class="placeholder-item-fh">' +
            '<span class="value">' +
            (itemId < 100 ? '0' : '') +
            (itemId < 10 ? '0' : '') +
            itemId +
            '</span></span>';
        }
      } else if (type === 'card' && split.length === 3) {
        const card = split[2];
        let cardValue = '';
        if (value) {
          cardValue = '<span class="card-value">' + value + '</span>';
        }
        image = '<img class="icon ghs-svg" src="./assets/images/action/card/' + card + '.svg">';
        const cardOverlay = '<img class="card-overlay" src="./assets/images/action/card/overlay/' + card + '.svg">';
        replace = '<span class="placeholder-effect placeholder-card">' + image + cardOverlay + cardValue + '</span>';
      } else if (type === 'attackmodifier' && split.length === 3 && split[2] !== 'rolling' && split[2] !== 'target') {
        image = '<img  src="./assets/images' + (fh ? '/fh' : '') + '/attackmodifier/icons/' + split[2] + '.png" class="icon">';
        replace = '<span class="placeholder-attackmodifier">' + image + '</span>';
      } else if (type === 'attackmodifier' && split.length === 3 && (split[2] === 'rolling' || split[2] === 'target')) {
        image = '<img  src="./assets/images/attackmodifier/' + split[2] + '.svg" class="icon">';
        replace = '<span class="condition-icon">' + image + '</span>';
      } else if (type === 'townGuardAM' && value) {
        replace = '<span class="placeholder-townguard-attackmodifier">' + value + '</span>';
        const townGuardAM = [...defaultTownGuardAttackModifier, ...additionalTownGuardAttackModifier].find((am) => am.id === value);
        if (townGuardAM) {
          const effect = townGuardAM.effects.find((effect) => effect.type === 'custom' && effect.icon);
          const effectImage =
            effect !== undefined ? '<img  src="./assets/images/action/custom/' + effect.value + '.svg" class="icon">' : '';
          let amImage =
            '<span class="townguard-attackmodifier"><img src="./assets/images/fh/attackmodifier/icons/' +
            townGuardAM.valueType +
            '.png" class="icon"><span class="value">' +
            (townGuardAM.value >= 0 ? '+' : '') +
            townGuardAM.value +
            '</span></span>';
          if (townGuardAM.type === AttackModifierType.wreck || townGuardAM.type === AttackModifierType.success) {
            amImage =
              '<span class="townguard-attackmodifier"><img src="./assets/images/fh/attackmodifier/icons/' +
              townGuardAM.type +
              '.png" class="icon"></span>';
          }
          const rollingImage = townGuardAM.rolling ? '<img  src="./assets/images/attackmodifier/rolling.svg" class="icon">' : '';
          replace = '<span class="placeholder-townguard-attackmodifier">' + effectImage + amImage + rollingImage + '</span>';
        }
      } else if (type === 'amDeck' && split.length === 3) {
        const deck = split[2];
        image = deck;
        if (deck !== 'M' && deck !== 'A') {
          image = '<img src="' + gameManager.characterManager.characterIcon(deck) + '" class="icon">';
        }
        replace = '<span class="placeholder-am-deck">' + image + '</span>';
      } else if (type === 'customAction' && value) {
        const effectImage = '<img  src="./assets/images/action/custom/' + value + '.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-custom-action">' + effectImage + '</span>';
      } else if (type === 'experience') {
        image = '<img  src="./assets/images/experience.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-experience">' + image + (value ? '<span class="value">' + value + '</span>' : '') + '</span>';
      } else if (type === 'characterIcon' && split.length === 3) {
        const characterName = split[2];
        image = '<img class="icon" src="' + gameManager.characterManager.characterIcon(characterName) + '">';
        replace = '<span class="placeholder-character-icon">' + image + '</span>';
      } else if (type === 'characterIconColored' && split.length === 3) {
        const characterName = split[2];
        image = '<img class="icon" src="' + gameManager.characterManager.characterIcon(characterName) + '">';
        replace = '<span class="placeholder-character-icon-colored">' + image + '</span>';
      } else if (type === 'characterIconColoredBg' && split.length === 3) {
        const characterName = split[2];
        image = '<img class="icon" src="' + gameManager.characterManager.characterIcon(characterName) + '">';
        replace =
          '<span class="placeholder-character-icon-colored-bg" style="background-color:' +
          gameManager.characterManager.characterColor(characterName) +
          '">' +
          image +
          '</span>';
      } else if (type === 'characterIconIdentity' && split.length === 4) {
        const characterName = split[2];
        const identity = +split[3];
        image = '<img class="icon" src="' + gameManager.characterManager.characterIdentityIcon(characterName, identity) + '">';
        replace = '<span class="placeholder-character-icon">' + image + '</span>';
      } else if (type === 'characterIconIdentityColored' && split.length === 4) {
        const characterName = split[2];
        const identity = +split[3];
        image = '<img class="icon" src="' + gameManager.characterManager.characterIdentityIcon(characterName, identity) + '">';
        replace = '<span class="placeholder-character-icon-colored">' + image + '</span>';
      } else if (type === 'characterIconIdentityColoredBg' && split.length === 4) {
        const characterName = split[2];
        const identity = +split[3];
        image = '<img class="icon" src="' + gameManager.characterManager.characterIdentityIcon(characterName, identity) + '">';
        replace =
          '<span class="placeholder-character-icon-colored-bg" style="background-color:' +
          gameManager.characterManager.characterColor(characterName) +
          '">' +
          image +
          '</span>';
      } else if (type === 'characterToken' && split.length >= 3) {
        const characterName = split[2];
        let icon = gameManager.characterManager.characterIcon(characterName);
        let additionalToken = false;
        if (split.length > 3) {
          icon = './assets/images/character/token/' + characterName + '-' + split[3] + '.svg';
          additionalToken = true;
        }
        image = '<img src="' + icon + '">';
        replace =
          '<span class="placeholder-character-token' +
          (additionalToken ? ' additional' : '') +
          '" style="--ghs-character-color:' +
          gameManager.characterManager.characterColor(characterName) +
          '">' +
          image +
          '</span>';
      } else if (type === 'coloredToken' && split.length > 3) {
        const color = split[2];
        const icon = './assets/images/character/custom/' + split[3] + '.svg';
        image = '<img src="' + icon + '">';
        replace = '<span class="placeholder-character-token" style="--ghs-character-color:#' + color + '">' + image + '</span>';
      } else if (type === 'characterColored') {
        const characterName = split[2];
        replace = '<span style="color: ' + gameManager.characterManager.characterColor(characterName) + ';">' + value + '</span>';
      } else if (type === 'monsterType' && split.length === 3) {
        const monsterType = split[2];
        replace =
          '<span class="placeholder-monster-type ' +
          monsterType +
          '">' +
          settingsManager.getLabel('game.monster.' + monsterType) +
          '</span>';
      } else if (type === 'monsterType' && split.length === 4) {
        const monsterType = split[2];
        replace = '<span class="placeholder-monster-type ' + monsterType + '">' + split[3] + '</span>';
      } else if (type === 'mapMarker' && split.length === 3) {
        if (split[2] === 'element') {
          image = '<img src="./assets/images/element/' + value + '.svg">';
          replace = '<span class="placeholder-element">' + image + '</span>';
        } else {
          replace = '<span class="map-marker">' + split[2] + '</span>';
        }
      } else if (type === 'objectiveMarker' && split.length === 3) {
        replace = '<span class="objective-marker">' + split[2] + '</span>';
      } else if (type === 'scenarioNumber') {
        replace = '<span class="scenario-number">' + value + '</span>';
      } else if (type === 'objectiveIcon' && split.length === 3) {
        image = '<img  src="./assets/images/objective/' + split[2] + '.svg" class="icon">';
        replace = '<span class="objective-icon">' + image + '</span>';
      } else if (fh && type === 'target' && split.length === 2) {
        image = '<img  src="./assets/images/fh/action/target.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-action">' + image + '</span>';
      } else if (!fh && type === 'damage') {
        replace = '<span class="damage">' + settingsManager.getLabel('game.damage', [value]) + '</span>';
      } else if (fh && type === 'damage') {
        image = '<img  src="./assets/images/fh/action/damage.svg" class="icon ghs-svg">';
        replace = '<span class="damage">&#8203;' + image + value + '</span>';
      } else if (type === 'loot' && split.length === 4) {
        image = '<img  src="./assets/images/' + split[3] + '-player.svg" class="icon">';
        replace = '<span class="placeholder-player">' + image + '</span>';
      } else if (type === 'resource' && split.length === 3) {
        image = '<img  src="./assets/images/fh/loot/' + split[2] + '.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-resource">' + image + '</span>';
      } else if (type === 'section' && value) {
        image = '<img src="./assets/images/fh/party/section.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-section">' + image + value + '</span>';
      } else if (type === 'gh2eFaction' && value) {
        image = '<img src="./assets/images/gh2e/faction/' + value + '.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-faction">' + image + '</span>';
      } else if (type === 'checkmark') {
        replace = '<span class="placeholder-checkmark"><img src="./assets/images/check.svg" class="icon ghs-svg"></span>';
      } else if (type === 'prosperity') {
        replace = '<span class="placeholder-prosperity"><img src="./assets/images/gh2e/prosperity.svg" class="icon ghs-svg"></span>';
      } else if (type === 'itemSlot' && value) {
        replace =
          '<span class="placeholder-items-slot"><img src="./assets/images/items/slots/' + value + '.svg" class="icon ghs-svg"></span>';
      } else if (type === 'bbAm' && split.length === 3) {
        replace =
          '<span class="placeholder-bb-am"><img src="./assets/images/bb/attackmodifier/' + split[2] + '.svg" class="icon ghs-svg"></span>';
      } else if (type === 'townGuardAm' && split.length === 3 && value) {
        const valueType = split[2];
        let valueSign = '';
        if (valueType === AttackModifierValueType.plus) {
          valueSign = '+';
        } else if (valueType === AttackModifierValueType.minus) {
          valueSign = '-';
        } else if (valueType === AttackModifierValueType.multiply) {
          valueSign = 'x';
        }
        replace = '<span class="placeholder-town-guard-am ' + split[2] + '">' + valueSign + value + '</span>';
      } else if (type === 'fhIcon' && value) {
        image = '<img src="./assets/images/fh/icons/' + value + '.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-fh-icon">' + image + '</span>';
      } else if (type === 'gameIcon' && value) {
        image = '<img src="./assets/images/' + value + '.svg" class="icon ghs-svg">';
        replace = '<span class="placeholder-game-icon">' + image + '</span>';
      } else if (type === 'statusIcon' && value) {
        image = '<img src="./assets/images/status/' + value + '.svg" class="icon">';
        replace = '<span class="placeholder-game-icon">' + image + '</span>';
      } else if (type === 'trait') {
        image = '<img src="./assets/images/fh/character/traits/trait.svg" class="icon ghs-svg">';
        replace =
          '<span class="placeholder-trait">' +
          image +
          (value ? settingsManager.getLabel('data.character.traits.' + value) : '') +
          '</span>';
      } else if (type === 'checkbox') {
        replace = '<span class="placeholder-checkbox"></span>';
      } else if (type === 'eventCard' && value) {
        replace = '<span class="placeholder-action"><img src="./assets/images/eventcards/' + value + '.svg" class="icon ghs-svg"></span>';
      } else if (type === 'eventCheckbox' && value) {
        replace = '<span class="event-checkbox">' + value + '</span>';
      } else if (type === 'valueSign' && value) {
        replace = '<span class="value-sign">' + (+value > -1 ? '+' : '') + value + '</span>';
      } else if (type === 'enhancement' && split.length === 3) {
        if (!fh || split[2] === 'any') {
          image = '<img class="enhancement-icon" src="./assets/images/character/abilities/enhancements/circle.svg">';
        } else {
          image = '<img class="enhancement-icon" src="./assets/images/fh/character/abilities/enhancements/' + split[2] + '.svg">';
        }
        replace = '<span class="placeholder-enhancement">' + image + '</span>';
      } else if (type === 'overlayCustomText' && value) {
        const edition = split[2];
        const group = split.length === 4 ? split[3] : undefined;
        const index = value;
        const conclusionModel = gameManager.game.party.conclusions.find(
          (conclusion) => conclusion.index === index && conclusion.edition === edition && conclusion.group === group && conclusion.custom
        );
        if (conclusionModel) {
          replace = '<span class="placeholder-overlay-custom-text">' + conclusionModel.custom + '</span>';
        } else {
          replace = '___________________';
        }
      } else if (type === 'tooltip' && value) {
        const label = settingsManager.getLabel(value);
        const text = settingsManager.getLabel(value + '.tooltip');
        replace = `<span class="hint-container inline">
        <span class="hint-trigger">${label}</span>
        <span class="hint center">
          <span class="text">
            <span>${text}</span>
          </span>
        </span>
      </span>`;
      } else {
        let labelArgs = label
          .split(':')
          .splice(1)
          .map((arg) => applyPlaceholder(settingsManager.getLabel(arg), placeholder, relative));
        if (value) {
          labelArgs = [value, ...labelArgs];
        }
        labelArgs.push(...placeholder);
        replace = settingsManager.getLabel(label.split(':')[0], labelArgs) + image;
      }

      return replace;
    });
  }

  output = applyValueCalc(output, relative);

  return output;
};

/** Replace Math.floor(X), Math.ceil(X), Math.min(X,N), Math.max(X,N) etc.
 * with localized display text when calculation is off.
 * Handles nested calls by recursively processing arguments.
 */
export function applyMathFunctionLabels(value: string): string {
  const mathFuncRegex = /Math\.(floor|ceil|round|abs|sqrt|minCeil|minFloor|maxCeil|maxFloor|min|max|pow)\(/g;
  let result = '';
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = mathFuncRegex.exec(value)) !== null) {
    const funcName = match[1];
    const argsStart = match.index + match[0].length;

    // find the balanced closing ')'
    let depth = 1;
    let i = argsStart;
    while (i < value.length && depth > 0) {
      if (value[i] === '(') depth++;
      else if (value[i] === ')') depth--;
      i++;
    }
    const argsStr = value.slice(argsStart, i - 1);

    // split top-level comma-separated arguments
    const args: string[] = [];
    let argDepth = 0;
    let argStart = 0;
    for (let j = 0; j < argsStr.length; j++) {
      if (argsStr[j] === '(') argDepth++;
      else if (argsStr[j] === ')') argDepth--;
      else if (argsStr[j] === ',' && argDepth === 0) {
        args.push(argsStr.slice(argStart, j).trim());
        argStart = j + 1;
      }
    }
    args.push(argsStr.slice(argStart).trim());

    // recursively process nested Math calls in each argument
    const processedArgs = args.map((a) => applyMathFunctionLabels(a));

    let replacement: string;
    switch (funcName) {
      case 'floor':
        replacement = processedArgs[0] + ' ' + settingsManager.getLabel('game.custom.math.floor');
        break;
      case 'ceil':
        replacement = processedArgs[0] + ' ' + settingsManager.getLabel('game.custom.math.ceil');
        break;
      case 'round':
        replacement = processedArgs[0] + ' ' + settingsManager.getLabel('game.custom.math.floor').replace('down', 'nearest');
        break;
      case 'abs':
        replacement = '|' + processedArgs[0] + '|';
        break;
      case 'sqrt':
        replacement = '√(' + processedArgs[0] + ')';
        break;
      case 'min': // Math.min(X, N) = cap at N = "up to a maximum of N"
        replacement =
          processedArgs[0] + ' ' + applyPlaceholder(settingsManager.getLabel('game.custom.math.max', [processedArgs[1] ?? '']), [], false);
        break;
      case 'minCeil':
        replacement =
          processedArgs[0] +
          ' ' +
          applyPlaceholder(settingsManager.getLabel('game.custom.math.minCeil', [processedArgs[1] ?? '']), [], false);
        break;
      case 'minFloor':
        replacement =
          processedArgs[0] +
          ' ' +
          applyPlaceholder(settingsManager.getLabel('game.custom.math.minFloor', [processedArgs[1] ?? '']), [], false);
        break;
      case 'max': // Math.max(X, N) = floor at N = "but at least N"
        replacement =
          processedArgs[0] + ' ' + applyPlaceholder(settingsManager.getLabel('game.custom.math.min', [processedArgs[1] ?? '']), [], false);
        break;
      case 'maxCeil':
        replacement =
          processedArgs[0] +
          ' ' +
          applyPlaceholder(settingsManager.getLabel('game.custom.math.maxCeil', [processedArgs[1] ?? '']), [], false);
        break;
      case 'maxFloor':
        replacement =
          processedArgs[0] +
          ' ' +
          applyPlaceholder(settingsManager.getLabel('game.custom.math.maxFloor', [processedArgs[1] ?? '']), [], false);
        break;
      case 'pow':
        replacement = processedArgs[0] + '^' + (processedArgs[1] ?? '');
        break;
      default:
        replacement = argsStr;
    }

    result += value.slice(lastIndex, match.index) + replacement;
    lastIndex = i;
    mathFuncRegex.lastIndex = lastIndex;
  }

  result += value.slice(lastIndex);
  return result;
}

export const applyValueCalc = function (value: string, relative: boolean): string {
  while (value.match(EntityValueRegex)) {
    value = value.replace(EntityValueRegex, (match, ...args) => {
      if (settingsManager.settings.calculate && !relative) {
        try {
          const result = EntityValueFunction(match);
          return '' + result;
        } catch {
          // unknown variable (e.g. HP) — fall through to display path
        }
      }

      return applyMathFunctionLabels(args[0]);
    });
  }

  return value;
};

@Directive({
  selector: '[ghs-label]'
})
export class GhsLabelDirective implements OnInit, OnChanges {
  private el = inject(ElementRef);
  private ghsManager = inject(GhsManager);

  readonly value = input.required<string | number>({ alias: 'ghs-label' });
  readonly args = input<(string | number | boolean)[]>([], { alias: 'ghs-label-args' });
  readonly argLabel = input<boolean>(true, { alias: 'ghs-label-args-replace' });
  readonly empty = input<boolean>(true, { alias: 'ghs-label-empty' });
  readonly attribute = input<string>('', { alias: 'ghs-label-attribute' });
  readonly slice = input<number[]>([]);
  readonly relative = input<boolean>(false);
  readonly style = input<'gh' | 'fh' | false>(false);

  private C: number;
  private L: number;
  private locale: string;
  private calc: boolean = false;
  private fhStyle: boolean = false;
  private ready: boolean = false;
  private valueChange: string | number = '';

  constructor() {
    this.ghsManager.uiChangeEffect(() => {
      const count = gameManager.levelManager.characterCountVariable();
      const value = this.value();
      if (
        !this.ready ||
        this.locale !== settingsManager.settings.locale ||
        this.C !== count ||
        this.L !== gameManager.game.level ||
        this.fhStyle !== settingsManager.settings.fhStyle ||
        this.calc !== settingsManager.settings.calculate ||
        this.valueChange !== value
      ) {
        this.C = count;
        this.L = gameManager.game.level;
        this.locale = settingsManager.settings.locale;
        this.calc = settingsManager.settings.calculate;
        this.fhStyle = settingsManager.settings.fhStyle;
        this.valueChange = value;
        this.ready = gameManager.stateManager.ready;
        this.apply();
      }
    });
    this.el.nativeElement.classList.add('placeholder');
    this.C = gameManager.levelManager.characterCountVariable();
    this.L = gameManager.game.level;
    this.locale = settingsManager.settings.locale;
    this.calc = settingsManager.settings.calculate;
    this.fhStyle = settingsManager.settings.fhStyle;
  }

  ngOnInit(): void {
    this.apply();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['args'] && JSON.stringify(changes['args'].previousValue) !== JSON.stringify(changes['args'].currentValue)) ||
      (changes['value'] && changes['value'].previousValue !== changes['value'].currentValue) ||
      (changes['style'] && changes['style'].previousValue !== changes['style'].currentValue)
    ) {
      this.apply();
    }
  }

  apply(): void {
    let args: string[] = this.args().map((arg) => '' + arg) || [];
    if (this.argLabel()) {
      args = args.map((arg) => applyPlaceholder(settingsManager.getLabel(arg, [], false, this.empty()), [], this.relative(), this.style()));
    }

    const valueValue = this.value();
    let value =
      typeof valueValue === 'number'
        ? valueValue
        : (valueValue &&
            applyPlaceholder(settingsManager.getLabel(valueValue, args, false, this.empty()), args, this.relative(), this.style())) ||
          '';

    const slice = this.slice();
    if (typeof value === 'string' && slice.length === 1) {
      value = value.slice(slice[0]);
    } else if (typeof value === 'string' && slice.length === 2) {
      value = value.slice(slice[0], slice[1]);
    }

    const attribute = this.attribute();
    if (attribute) {
      this.el.nativeElement.setAttribute(attribute, value);
    } else {
      this.el.nativeElement.innerHTML = value;
    }
  }
}

@Directive({
  selector: '[ghs-label-element]'
})
export class GhsLabelElementDirective implements OnInit {
  private el = inject(ElementRef);

  value: string = '';
  readonly prefix = input<string>('', { alias: 'ghs-label-element' });

  constructor() {
    this.el.nativeElement.classList.add('placeholder');
  }

  ngOnInit(): void {
    this.value = this.el.nativeElement.textContent;
    this.apply();
  }

  apply(): void {
    const prefix = this.prefix();
    const value = (this.value && applyPlaceholder(settingsManager.getLabel((prefix ? prefix + '.' : '') + this.value))) || '';
    if (value) {
      this.el.nativeElement.innerHTML = value;
    }
  }
}
